import ContlyRightSidebarDesktop from './ContlyRightSidebarDesktop';

// Note: Mobile uses bottom sheets in views, not slide-in drawers
export default function ContlyRightSidebar({ isOpen, onClose, ...props }) {
  // Only render desktop version (AppMain already gates this with isDesktop)
  return <ContlyRightSidebarDesktop {...props} />;
}

